import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactModal from 'react-modal';

import {PATIENTS_LIST_MOBILE_MAX_WIDTH} from 'sources/constants/screenSizes';

import styles from './Dialog.scss';
import CustomGrid from 'components/controls/grid/CustomGrid';
import WarningIcon from 'components/controls/icons/WarningIcon';
import Button from 'components/controls/buttons/Button';
import CustomBox from 'components/controls/grid/CustomBox';
import SlideUp from 'components/controls/transitions/SlideUp';

export default class Dialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
        shouldCloseOnOverlayClick: PropTypes.bool,
        title: PropTypes.any,
        containerClassName: PropTypes.any,
        dialogClassName: PropTypes.any,
        contentClassName: PropTypes.any,
        headerClassName: PropTypes.any,
        children: PropTypes.any,
        onClose: PropTypes.func,
        isLong: PropTypes.bool,
        scrollBarConfig: PropTypes.object,
        withConfirmation: PropTypes.bool,
        confirmationText: PropTypes.any,
        confirmationOkButtonLabel: PropTypes.string,
        confirmationCancelButtonLabel: PropTypes.string,
    };

    static defaultProps = {
        visible: true,
        withConfirmation: false,
        shouldCloseOnOverlayClick: true,
        confirmationOkButtonLabel: loc('proceed'),
        confirmationCancelButtonLabel: loc('cancel-label'),
        confirmationText: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            confirmationDisplayed: props.withConfirmation,
        };
    }

    closeConfirmation = () => {
        this.setState({
            confirmationDisplayed: false,
        });
    }

    renderConfirmation() {
        const {
            confirmationText,
            confirmationOkButtonLabel,
            confirmationCancelButtonLabel,
            onClose,
        } = this.props;

        const {confirmationDisplayed} = this.state;

        if (!confirmationDisplayed) {
            return null;
        }

        return (
            <CustomGrid
                container
                direction="column"
                justify="flex-end"
                className={styles.confirmationOverlay}
            >
                <CustomGrid
                    item
                    xs={12}
                    container
                    className={styles.confirmationDialog}
                >

                    <CustomBox
                        m="xxl"
                    >
                        <CustomGrid
                            container
                            direction="column"
                            className={styles.confirmationBody}
                            justify="space-between"
                        >
                            <CustomGrid
                                item
                            >
                                <WarningIcon className={styles.confirmationIcon} />
                            </CustomGrid>
                            <CustomGrid
                                item
                            >
                                {confirmationText}
                            </CustomGrid>
                            <CustomGrid
                                item
                                container
                                spacing="m"
                            >
                                <CustomGrid
                                    item
                                    xs={6}
                                >
                                    <Button
                                        color="tertiary"
                                        onClick={onClose}
                                        label={confirmationCancelButtonLabel}
                                    />
                                </CustomGrid>
                                <CustomGrid
                                    item
                                    xs={6}
                                >
                                    <Button
                                        color="secondary"
                                        onClick={this.closeConfirmation}
                                        label={confirmationOkButtonLabel}
                                    />
                                </CustomGrid>
                            </CustomGrid>
                        </CustomGrid>
                    </CustomBox>
                </CustomGrid>
            </CustomGrid>
        );
    }

    getDialogContent(isMobileView) {
        const {
            title,
            children,
            containerClassName,
            contentClassName,
            headerClassName,
            withConfirmation,
            isLong,
            onClose,
            ...restProps
        } = this.props;
        const {confirmationDisplayed} = this.state;

        const bodyClassName = classNames(containerClassName, styles.body);
        const wrapper = classNames(contentClassName, styles.contentWrapper, isLong ? styles.long : '');
        const header = classNames(headerClassName, styles.header);

        return (
            <div className={wrapper} {...restProps}>
                <header className={header}>
                    {title}
                </header>

                <section className={bodyClassName}>
                    {children}
                    {this.renderConfirmation()}
                </section>
                {onClose && isMobileView &&
                    <div className={styles.closeButton}
                        onClick={onClose}></div>}
            </div>
        )
    }

    render() {
        const {
            visible,
            shouldCloseOnOverlayClick,
            dialogClassName,
            onClose
        } = this.props;

        const className = classNames(dialogClassName, styles.dialog);
        const isMobileView = window
            && window.matchMedia(`screen and (max-width: ${PATIENTS_LIST_MOBILE_MAX_WIDTH}px)`).matches;

        return (
            <ReactModal isOpen={visible}
                ariaHideApp={false}
                overlayClassName={styles.overlay}
                className={className}
                contentLabel=''
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                onRequestClose={onClose}
                >
                {this.getDialogContent(isMobileView)}
                {onClose && !isMobileView &&
                    <div className={styles.closeButton}
                        onClick={onClose} />}
            </ReactModal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/dialogs/Dialog.js